import axiosInstance from '../../../services/axios/axios';
import { WrapImsPacket } from '../../../store/utility';

/**
 * Submit an Unsanctioned AI Exception
 *
 */
export const SubmitUnsanctionedAIException = async ExceptionArgs => {
	try {
		const response = await axiosInstance.post(
			`api/UnsanctionedAIException/Submission`,
			WrapImsPacket(ExceptionArgs)
		);

		return response;
	} catch (ex) {
		console.error('Unable to submit exception: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Search for Person
 *
 */
export const fetchPersonSearch = async payload => {
	try {
		const response = await axiosInstance.post(
			`api/Components/PersonSearch`,
			payload
		);
		return response;
	} catch (ex) {
		console.error('Unable to fetch person search: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};